/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationEquipmentsAliases {
  CHECKBOX_0 = 'checkbox-0',
  DYNAMIC_FIELD_AVAILABLE_SUS = 'dynamic-field-available-sus',
  FETCH_EQUIPMENTS = 'fetch-equipments',
  FETCH_LIST = 'fetch-list',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_TYPE_EQUIPMENT = 'fetch-type-equipment',
  FIELD_0 = 'field-0',
  FIELD_AMOUNT_EQUIPMENT = 'field-amount-equipment',
  FIELD_AMOUNT_EQUIPMENT_USE = 'field-amount-equipment-use',
  FIELD_AMOUNT_EQUIPMENT_USE_LIST = 'field-amount-equipment-use-list',
  FIELD_AMOUNT_LIST = 'field-amount-list',
  FIELD_AVAILABLE_SUS = 'field-available-sus',
  FIELD_CARD = 'field-card',
  FIELD_EQUIPMENT = 'field-equipment',
  FIELD_EQUIPMENT_LIST = 'field-equipment-list',
  FIELD_NR_SEQUENCE = 'field-nrSequence',
  FIELD_NR_SEQUENCE_LIST = 'field-nrSequence-list',
  FIELD_TYPE_EQUIPMENT = 'field-type-equipment',
  FIELD_TYPE_EQUIPMENT_LIST = 'field-type-equipment-list',
  FORM_0 = 'form-0',
  FORM_EQUIPMENT = 'form-equipment',
  FORM_PANEL = 'form-panel',
  INPUT_NR_SEQUENCE = 'input-nrSequence',
  INPUT_NR_SEQUENCE_LIST = 'input-nrSequence-list',
  INPUT_QUANTITY = 'input-quantity',
  INPUT_QUANTITY_EQUIPMENT_USE = 'input-quantity-equipment-use',
  LAYOUT_GENERAL_INFORMATION = 'layout-general-information',
  LIST_PANEL = 'list-panel',
  MAPPER_0 = 'mapper-0',
  MAPPER_EQUIPMENT = 'mapper-equipment',
  MAPPER_TYPE = 'mapper-type',
  MY_DATA_CARD = 'my-data-card',
  MY_DATA_DECK = 'my-data-deck',
  PANEL_ACCREDITATION_EQUIPMENTS = 'panel-accreditation-equipments',
  PANEL_PENDENCIES = 'panel-pendencies',
  TEXT_3_LIST = 'text-3-list',
  TEXT_4_LIST = 'text-4-list',
  TEXT_5_LIST = 'text-5-list',
  TEXT_EQUIPMENT = 'text-equipment',
  TEXT_TYPE = 'text-type',
  TEXT_TYPE_LIST = 'text-type-list',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_AUTOCOMPLETE_EQUIPMENT = 'unboxed-autocomplete-equipment',
  UNBOXED_AUTOCOMPLETE_TYPE_EQUIPMENT = 'unboxed-autocomplete-type-equipment',
}
export { ProviderAccreditationEquipmentsAliases };
